import FieldTypesEnum from '../Enums/FieldTypesEnum';
import React from 'react';
import FigmaBadge from '../Elements/FigmaBadge';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import JsxHelper from '../Helpers/JsxHelper';

export default class TaxItem {
  constructor(item) {
    if (item === undefined) {
      this.TaxId = '';
      this.EntityTypeId = '';
      this.EntityId = '';
      this.OfficeId = '';
      this.Name = '';
      this.ItemCode = '';
      this.Rate = '';
      this.Description = '';
      this.ApplyToAssignmentFees = '';
      this.ApplyToAssignmentReimbursements = '';
      this.ApplyToLineItemFees = '';
      this.ApplyToLineItemReimbursements = '';
      this.ApplyToFeePrepayments = '';
      this.ApplyToReimbursementPrepayments = '';
      this.TaxesPaidBy = '1';
      this.ThirdPartyName = '';
      this.Inactive = '';
      this.CreatedBy = '';
      this.CreatedOn = '';
      this.ModifiedBy = '';
      this.ModifiedOn = '';
      this.Office = '';
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.TaxId = item.taxId;
    this.EntityTypeId = item.entityTypeId;
    this.EntityId = item.entityI;
    this.OfficeId = item.officeId;
    this.Name = item.name;
    this.ItemCode = item.itemCode;
    this.Rate = item.rate;
    this.Description = item.description;
    this.ApplyToAssignmentFees = item.applyToAssignmentFees;
    this.ApplyToAssignmentReimbursements = item.applyToAssignmentReimbursements;
    this.ApplyToLineItemFees = item.applyToLineItemFees;
    this.ApplyToLineItemReimbursements = item.applyToLineItemReimbursements;
    this.ApplyToFeePrepayments = item.applyToFeePrepayments;
    this.ApplyToReimbursementPrepayments = item.applyToReimbursementPrepayments;
    this.TaxesPaidBy = item.taxesPaidBy;
    this.ThirdPartyName = item.thirdPartyName;
    this.Inactive = item.inactive;
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOn = item.modifiedOn;
    this.Office = item.office;
  }

  static NameOfTheIdField = () => 'EvId';

  static nameOfTheItemDetailList = () => 'Tax';
  static Currency = () => 'USD';
  static CurrencySecondary = () => 'USD';

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'Name', label: 'Tax Name' },
        {
          name: (item) => TaxItem.getIsActiveCellContent(item.ApplyToAssignmentFees),
          label: 'Apply To Assignment Fees?',
        },
        { name: 'Rate', label: 'Rate %' },
        {
          name: (item) => TaxItem.getIsActiveCellContent(item.ApplyToAssignmentReimbursements),
          label: 'Apply To Assignment Reimbursements?',
        },
        { name: 'Office', label: 'Tax Office' },
        { name: (item) => TaxItem.getIsActiveCellContent(item.ApplyToLineItemFees), label: 'Apply To Line Item Fees?' },
        { name: 'TaxesPaidBy', label: 'Taxes Paid By' },
        {
          name: (item) => TaxItem.getIsActiveCellContent(item.ApplyToLineItemReimbursements),
          label: 'Apply To Line Item Reimbursements?',
        },
        { name: 'ThirdPartyName', label: '3rd Party Name' },
        { name: (item) => TaxItem.getIsActiveCellContent(item.ApplyToFeePrepayments), label: 'Apply To Prepay Fees?' },
        { name: 'Description', label: 'Description' },
        {
          name: (item) => TaxItem.getIsActiveCellContent(item.ApplyToReimbursementPrepayments),
          label: 'Apply to Prepay Reimbursements?',
        },
        { name: 'ItemCode', label: 'Item Code' },
        { name: (item) => TaxItem.getIsActiveCellContent(item.Inactive), label: 'Is Active?' },
      ],
    },
  ];

  static getIsActiveCellContent(bool) {
    return (
      <div className='pointer'>
        {
          <FigmaBadge
            Active={bool}
            ActiveText='Yes'
            InactiveText='No'
            width={50}
          />
        }
      </div>
    );
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'TaxId', orderById: 'TaxId', data: 'TaxId', type: FieldTypesEnum.DataFieldWithDetails, minWidth: 50 },
      { label: 'Name', orderById: 'Name', data: 'Name' },
      { label: 'Item Code', orderById: 'ItemCode', data: 'ItemCode', minWidth: 50 },
      { label: 'Rate', orderById: 'Rate', data: 'Rate', minWidth: 50 },
      { label: 'Description', orderById: 'Description', data: 'Description', minWidth: 50 },
      { label: 'Active', orderById: '', data: (item) => JsxHelper.YesNo(!item.Inactive), minWidth: 50 },
      { label: ' ', data: TaxItem.getDetailCellContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static getDetailCellContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            onClick: () => TaxItem.editFunction(item),
            text: 'Edit',
            hide: item.EntityTypeId !== 72,
          },
          {
            iconName: item.Inactive ? 'fa-solid fa-toggle-on' : 'fa-solid fa-toggle-off',
            onClick: () => TaxItem.activateDeactivate(item),
            text: item.Inactive ? 'Activate' : 'Deactivate',
            hide: item.EntityTypeId !== 72,
          },
          {
            iconName: item.Inactive ? 'fa-solid fa-toggle-on' : 'fa-solid fa-toggle-off',
            onClick: () => TaxItem.deleteTaxFunction(item),
            text: 'Remove',
            hide: item.EntityTypeId === 72 || TaxItem.isDeleteHidden(),
          },
        ]}
      />
    );
  }

  static deleteTaxFunction(item) {
    //This is just a placeholder
  }

  static editFunction(item) {
    //This is just a placeholder
  }

  static activateDeactivate(item) {
    //This is just a placeholder
  }

  static isDeleteHidden() {
    return false;
  }
}
